"use client"

import { useGlobalDialogStore } from "@/stores/use-global-dialog-store"

import { AppDialogContent } from "./app-dialog-content"

interface ArtifactEditDialogProps {
  title: string
  chat: React.ReactNode
  preview: React.ReactNode
  closeCallback?: () => void
}

export function ArtifactEditDialogContent({ title, chat, preview }: ArtifactEditDialogProps) {
  return (
    <AppDialogContent variant="fullscreen" title={title}>
      <div className="grid h-full min-h-0 grid-cols-1 gap-4 lg:grid-cols-[400px_minmax(0,1fr)]">
        <div className="min-h-0">{chat}</div>
        <div className="min-h-0">{preview}</div>
      </div>
    </AppDialogContent>
  )
}

export function useArtifactEditDialog() {
  const { openDialog } = useGlobalDialogStore()

  return ({ title, chat, preview, closeCallback }: ArtifactEditDialogProps) =>
    openDialog({
      variant: "fullscreen",
      content: <ArtifactEditDialogContent title={title} chat={chat} preview={preview} />,

      closeCallback,
    })
}
